import React from "react";
import { Tooltip, makeStyles, SvgIcon } from "@material-ui/core";

// Ícone customizado "Online": círculo verde + check branco
const OnlineIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      {/* Círculo verde com raio = 10 */}
      <circle cx="12" cy="13" r="10" fill="#008000" />
      {/* Check branco */}
      <path
        fill="#ffffff"
        d="M16.6,8.6L10,15.2L7.4,12.6l-1.4,1.4l4,4l8-8L16.6,8.6z"
      />
    </SvgIcon>
  );
};

// Ícone customizado "Offline": círculo vermelho + X branco
const OfflineIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      {/* Círculo vermelho com raio = 10 */}
      <circle cx="12" cy="13" r="10" fill="#FF0000" />
      {/* X branco */}
      <path
        fill="#ffffff"
        d="M15.7,8.3l-3.7,3.7l-3.7-3.7l-1.4,1.4l3.7,3.7l-3.7,3.7l1.4,1.4l3.7-3.7l3.7,3.7l1.4-1.4
        l-3.7-3.7l3.7-3.7L15.7,8.3z"
      />
    </SvgIcon>
  );
};

const useStyles = makeStyles(() => ({
  iconSize: {
    width: 24,
    height: 24,
  },
}));

const UserStatusIcon = ({ user }) => {
  const classes = useStyles();

  return user.online ? (
    <Tooltip title="Online">
      <OnlineIcon className={classes.iconSize} />
    </Tooltip>
  ) : (
    <Tooltip title="Offline">
      <OfflineIcon className={classes.iconSize} />
    </Tooltip>
  );
};

export default UserStatusIcon;
